export default __webpack_public_path__ + "static/media/logo.33f2d0e8.png";